import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { useInView } from "@/shared/hooks/useInView"
import { Reveal } from "@/shared/ui/Reveal"
import { Section } from "@/shared/ui/Section"
import { Icon } from "@/shared/ui/icons"

/** Faixa verde de pilares da marca, logo abaixo do hero. */
export function TrustSection() {
  const { trustHighlights } = useSiteContent()
  const { ref, inView } = useInView()

  return (
    <Section ref={ref} tone="verde" padding="none" className="py-12 lg:py-14" aria-label="Diferenciais DIMPET">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 lg:gap-10">
        {trustHighlights.map((item, index) => (
          <Reveal key={item.label} inView={inView} delayMs={index * 80} distance="sm" className="flex flex-col gap-3">
            <div className="w-11 h-11 rounded-xl bg-off-white/8 flex items-center justify-center text-dourado-claro">
              <Icon name={item.icon} />
            </div>
            <div>
              <p className="font-semibold text-off-white text-sm leading-snug">{item.label}</p>
              <p className="text-off-white/55 text-xs leading-relaxed mt-0.5">{item.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  )
}
